import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GoldPriceCategory from "../pages/category/gold-price/page";
import InvestmentNewsCategory from "../pages/category/investment-news/page";
import PriceDetail from "../pages/detail/price/page";
import NewsDetail from "../pages/detail/news/page";
import SearchPage from "../pages/search/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category/gold-price",
    element: <GoldPriceCategory />,
  },
  {
    path: "/category/investment-news",
    element: <InvestmentNewsCategory />,
  },
  {
    path: "/detail/price/:id",
    element: <PriceDetail />,
  },
  {
    path: "/detail/news/:id",
    element: <NewsDetail />,
  },
  {
    path: "/search",
    element: <SearchPage />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;